/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Search } from "../components/searchUtils";
import { Pagination } from "../components/Pagination";
import { _PAGE_SIZE_ } from "../../lib/other/tools";
import { usePageContext } from "../../context/PageContext";
import { defaultImage } from "../../lib/libraries/imageKit/ImageKit";
import {
  FiMapPin,
  FiTag,
  FiPlus,
  FiMinus,
  FiCheck,
  FiX,
  FiInfo,
} from "react-icons/fi";

const AttractionsList = ({ setPages, pages }) => {
  const { attractions, fetchAttractions, attractionsCount } = usePageContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);
  const [attractionsList, setAttractionsList] = useState(null);
  const [modal, setModal] = useState({ open: false, action: null, payload: null });

  useEffect(() => {
    if (!attractions) fetchAttractions(page, pageSize);
    else setAttractionsList(attractions);
  }, [attractions]);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    if (!attractions) return;
    const arr = attractions.filter((a) => String(a.title).toLowerCase().includes(key));
    setAttractionsList(key ? arr : attractions);
  };

  const slugify = (t) => String(t || "").toLowerCase().replace(/\s/g, "_");
  const isAdded = (s) => pages?.some((p) => p.slug === s);

  const onAdd = (a) => setModal({ open: true, action: "add", payload: a });
  const onRemove = (a) => setModal({ open: true, action: "remove", payload: a });

  const confirm = () => {
    const a = modal.payload;
    if (!a) return setModal({ open: false, action: null, payload: null });
    const s = slugify(a.title);
    if (modal.action === "add") {
      setPages([
        ...pages,
        {
          title: a.title,
          hashtag: `attraction/${a.attraction_id}`,
          thumbnail: a.thumbnail ? a.thumbnail : defaultImage,
          image_cdn_id: a.thumbnailId ? a.thumbnailId : "...",
          description: a.description,
          slug: s || ".",
          category: a.category,
          status: 1,
        },
      ]);
    }
    if (modal.action === "remove") {
      setPages(pages.filter((val) => val.slug !== s));
    }
    setModal({ open: false, action: null, payload: null });
  };

  return (
    <div className="mb-5 w-full py-2">
      <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div className="flex flex-col gap-3 px-3 py-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-2">
            <span className="grid h-9 w-9 place-items-center rounded-lg bg-gray-900 text-white">
              <FiMapPin className="h-5 w-5" />
            </span>
            <div>
              <div className="text-sm font-semibold text-gray-900">Attractions</div>
              <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px]">
                <span className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-gray-700">
                  <FiTag className="h-3.5 w-3.5" />
                  {attractionsList ? attractionsList.length.toLocaleString() : 0} results
                </span>
                <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-emerald-700">
                  <FiInfo className="h-3.5 w-3.5" />
                  Click Add to include in page
                </span>
              </div>
            </div>
          </div>
          <div className="w-full sm:w-80">
            <Search
              props={{
                title: "Search attractions…",
                onChange: (e) => SearchList(e),
              }}
            />
          </div>
        </div>

        <div className="relative max-h-[60vh] overflow-auto rounded-b-2xl">
          <table className="min-w-full table-fixed text-sm">
            <thead className="sticky top-0 z-10 bg-white/90 backdrop-blur">
              <tr className="text-left text-xs uppercase tracking-wide text-gray-500">
                <th className="w-[55%] px-3 py-3 font-semibold">
                  <span className="inline-flex items-center gap-2">
                    <FiTag className="h-4 w-4" />
                    Title
                  </span>
                </th>
                {/* <th className="w-[25%] px-3 py-3 font-semibold">
                  <span className="inline-flex items-center gap-2">
                    <FiCalendar className="h-4 w-4" />
                    Open Days
                  </span>
                </th> */}
                <th className="px-3 py-3 text-center font-semibold">Action</th>
              </tr>
            </thead>
            <tbody>
              {attractions && attractionsList ? (
                attractionsList.map((a) => {
                  const s = slugify(a.title);
                  const added = isAdded(s);
                  return (
                    <tr key={a.attraction_id} className="border-t border-gray-100 hover:bg-gray-50/70">
                      <td className="px-3 py-3 align-middle">
                        <div className="flex items-center gap-3">
                          <img
                            src={a.thumbnail || defaultImage}
                            alt=""
                            className="h-9 w-9 rounded-lg object-cover ring-1 ring-gray-200"
                          />
                          <div className="min-w-0">
                            <div className="truncate font-semibold text-gray-900">
                              {a.title}
                            </div>
                            <div className="truncate text-[11px] text-gray-500">#{a.attraction_id}</div>
                          </div>
                        </div>
                      </td>
                      {/* <td className="px-3 py-3 align-middle">
                        <span className="inline-flex items-center gap-2 rounded-lg bg-gray-100 px-2.5 py-1 text-[11px] font-semibold text-gray-700 ring-1 ring-gray-200">
                          <FiCalendar className="h-3.5 w-3.5" />
                          {a.open_days}
                        </span>
                      </td> */}
                      <td className="px-3 py-3 align-middle">
                        <div className="flex items-center justify-center">
                          {added ? (
                            <button
                              type="button"
                              onClick={() => onRemove(a)}
                              className="inline-flex items-center gap-2 rounded-lg bg-orange-600 px-3 py-2 text-xs font-semibold text-white shadow hover:bg-orange-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
                            >
                              <FiMinus className="h-4 w-4" />
                              Remove
                            </button>
                          ) : (
                            <button
                              type="button"
                              onClick={() => onAdd(a)}
                              className="inline-flex items-center gap-2 rounded-lg bg-emerald-600 px-3 py-2 text-xs font-semibold text-white shadow hover:bg-emerald-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
                            >
                              <FiPlus className="h-4 w-4" />
                              Add
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td className="px-3 py-6 text-center text-gray-500" colSpan={3}>
                    Loading…
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="border-t border-gray-100 px-3 py-3">
          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={attractionsCount}
            callbackFunction={(_p, _s) => fetchAttractions(_p, _s)}
          />
        </div>
      </div>

      <ConfirmModal
        open={modal.open}
        title={modal.action === "add" ? "Add this attraction to the page?" : "Remove this attraction from the page?"}
        description={
          modal.payload
            ? modal.action === "add"
              ? `“${modal.payload.title}” will be included in your page.`
              : `“${modal.payload.title}” will be removed from your page.`
            : ""
        }
        onCancel={() => setModal({ open: false, action: null, payload: null })}
        onConfirm={confirm}
        confirmText={modal.action === "add" ? "Add" : "Remove"}
        tone={modal.action === "remove" ? "danger" : "primary"}
      />
    </div>
  );
};

export default AttractionsList;

const ConfirmModal = ({
  open,
  title,
  description,
  onCancel,
  onConfirm,
  confirmText = "Proceed",
  tone = "primary",
}) => {
  if (!open) return null;
  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
      aria-describedby="confirm-desc"
      className="fixed inset-0 z-[2147483647] isolate flex items-center justify-center p-4"
    >
      <div className="absolute inset-0 bg-black/70 backdrop-blur-[2px]" onClick={onCancel} />
      <div className="relative w-full max-w-md rounded-2xl border border-gray-200 bg-white/95 shadow-2xl ring-1 ring-black/5 supports-[backdrop-filter]:bg-white/85">
        <div className="absolute inset-x-0 top-0 h-1 rounded-t-2xl" />
        <div className="relative px-5 pt-5">
          <div className="flex items-start gap-3">
            <span
              className={[
                "grid h-9 w-9 place-items-center rounded-lg",
                tone === "danger" ? "bg-red-100 text-red-700" : "bg-emerald-100 text-emerald-700",
              ].join(" ")}
            >
              {tone === "danger" ? <FiMinus className="h-5 w-5" /> : <FiPlus className="h-5 w-5" />}
            </span>
            <div>
              <h3 id="confirm-title" className="text-base font-semibold text-gray-900">
                {title}
              </h3>
              {description ? (
                <p id="confirm-desc" className="mt-1 text-sm text-gray-600">{description}</p>
              ) : null}
            </div>
          </div>
        </div>
        <div className="px-5 pb-5 pt-4 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
          >
            <FiX className="h-4 w-4" />
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={[
              "inline-flex items-center gap-2 rounded-lg px-3 py-2 text-xs font-semibold text-white shadow focus:outline-none focus-visible:ring-2",
              tone === "danger"
                ? "bg-orange-600 hover:bg-orange-700 focus-visible:ring-orange-500"
                : "bg-emerald-600 hover:bg-emerald-700 focus-visible:ring-emerald-500",
            ].join(" ")}
          >
            <FiCheck className="h-4 w-4" />
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
